import { render, staticRenderFns } from "./iconMail.vue?vue&type=template&id=0ec285a2&scoped=true&"
import script from "./iconMail.vue?vue&type=script&lang=js&"
export * from "./iconMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec285a2",
  null
  
)

export default component.exports